<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="LINESPACE" id="ded"> </p>
<p class="LINESPACE"> </p>
<p class="DED">This book is dedicated to a modern-day man of undaunted courage and perseverance of purpose—</p>
<p class="DED"> </p>
<p class="DED"><span class="ePub-B">Battalion Chief Orio Joseph Palmer,</span></p>
<p class="DED">New York City Fire Department,</p>
<p class="DED">who died on the 78th floor</p>
<p class="DED">when the South Tower fell</p>
<p class="DED">on</p>
<p class="DED">September 11, 2001.</p>
<p class="DED">His remains were never found.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a16818b4